<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 22:33:18
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 01:39:17
-->
<template>
  <div class="dispatchAdd">
    <div class="nav">
      <img
        class="back"
        src="../../../assets/workOrder/back.png"
        alt=""
        @click="onClickBack"
      />
      <p class="title">发布货源</p>
      <div></div>
    </div>

    <div class="form">
      <van-form @submit="onSubmit">
        <div class="boxon">
          <div class="huoname">
            <img
              src="../../../assets/accountant/icon.png"
              class="icon"
              alt=""
            />
            <span>货盘名称:</span>
            <span>{{ name || "--" }}</span>
          </div>
          <van-field
            autocomplete="off"
            v-model="addForm.loadDate"
            name="picker"
            label="预装时间"
            placeholder="请选择预装时间"
            readonly
            @click="planyue"
            :rules="[{ required: true, message: '请选择预装时间' }]"
            right-icon="arrow-down"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.loadDays"
            name="装卸天数"
            label="装卸天数(天)"
            placeholder="请填写装卸天数"
            required
            :rules="[{ required: true, message: '请填写装卸天数' }]"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.cargoOwner"
            name="运输单位"
            label="运输单位"
            placeholder="请填写运输单位"
            required
            readonly
            @click="showCus"
            :rules="[{ required: true, message: '请填写运输单位' }]"
            right-icon="arrow-down"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.tonnage"
            name="最小载重吨位"
            label="最小载重吨位"
            placeholder="请填写最小载重吨位"
            required
            :rules="[{ required: true, message: '请填写最小载重吨位' }]"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.cabintype"
            name="封仓方式"
            label="封仓方式"
            placeholder="请选择封仓方式"
            required
            readonly
            @click="feng"
            :rules="[{ required: true, message: '请选择封仓方式' }]"
            right-icon="arrow-down"
          />

          <van-field
            autocomplete="off"
            v-model="addForm.remark"
            name="备注"
            label="备注"
            placeholder="请填写备注"
          />

          <van-field
            autocomplete="off"
            v-model="addForm.deposit"
            name="定金"
            label="定金(元)"
            placeholder="请输入定金"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.freightPrice"
            name="运价:"
            label="运价(元/吨)"
            placeholder="请输入运价"
            type="digit"
          />
          <van-field
            autocomplete="off"
            v-model="addForm.demurrage"
            name="滞期费:"
            label="滞期费(元/吨/天)"
            placeholder="请输入运价滞期费"
          />
        </div>

        <div style="margin: 45px 25px 0">
          <van-button round block type="info" native-type="submit"
            >发布</van-button
          >
        </div>
      </van-form>
    </div>
    <van-popup v-model="showUnit" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="请选择"
        visible-item-count="4"
        :columns="portList"
        @confirm="onConfirm"
        value-key="label"
        @cancel="onCancel"
      />
    </van-popup>
    <van-popup v-model="transf" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="封仓方式"
        visible-item-count="4"
        :columns="transferssList"
        @confirm="onConfirm1"
        value-key="dictLabel"
        @cancel="onCancel1"
      />
    </van-popup>
    <van-popup v-model="pandata" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择预装时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="panlick"
        @cancel="canceldata"
      />
    </van-popup>
    <van-popup v-model="customer" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="选择客户"
        visible-item-count="4"
        :columns="customerList"
        @confirm="onConfirm2"
        value-key="carrierName"
        @cancel="onCancel2"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  releasefr,
  optionSelect,
  searchDictData,
} from "@/utils/network/interface";
export default {
  name: "dispatchAdd",
  components: {},
  props: {},
  data() {
    return {
      addForm: {
        loadDate: "", //预装时间
        loadDays: "", //装卸天数
        cargoOwner: "", //运输单位
        cargoOwnerId: "", //运输单位id
        tonnage: "", //最小载重吨位
        cabintype: "", //封仓方式
        remark: "", //备注
        deposit: "", //定金
        freightPrice: "", //运价
        demurrage: "", //滞期费
        id: this.$route.query.id,
      },
      name: this.$route.query.palletsName,
      showUnit: false,
      transf: false,
      customer: false,
      pandata: false,
      portList: [],
      transferssList: [],
      customerList: [],
      type: "origin",
      minDate: new Date(2019, 0),
      maxDate: new Date(2050, 12),
      currentDate: new Date(),
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.dispatchGetPort();
    // this.transferssfrom();
    this.dispatchGetCustomer();
    this.searchDictData();
  },
  mounted() {},
  methods: {
    // formatter(type, val) {
    //   if (type === 'year') {
    //     return `${val}年`;
    //   } else if (type === 'month') {
    //     return `${val}月`;
    //   }
    //   return val;
    // },

    onSubmit(values) {
      console.log(this.addForm);
      releasefr(this.addForm).then((res) => {
        if (res.code === 200) {
          history.go(-1);
        } else {
        }
      });
    },
    // dispatchGetPort() {
    //   dispatchGetPort().then((res) => {
    //     console.log(res);
    //     res.data.map((c) => {
    //       let obj = {
    //         label: c.label,
    //         children: c.options,
    //       };
    //       this.portList.push(obj);
    //     });
    //   });
    // },
    searchDictData() {
      searchDictData().then((res) => {
        this.transferssList = res.data.sealingEquipment;
        console.log(res, "zidian ");
      });
    },

    dispatchGetCustomer() {
      optionSelect().then((res) => {
        this.customerList = res.data;
        console.log(res, "运输单位");
      });
    },

    showPick(type) {
      this.type = type;
      this.$nextTick(() => {
        this.showUnit = true;
      });
    },
    feng() {
      this.transf = true;
    },

    showCus() {
      this.customer = true;
    },
    onConfirm(value, index) {
      this.addForm[this.type] = value[1];
      this.showUnit = false;
      this.type = "";
    },
    onCancel() {
      this.type = "";
      this.showUnit = false;
    },
    onConfirm1(vale) {
      console.log(vale.dictLabel);
      this.addForm.cabintype = vale.dictLabel;
      this.transf = false;
    },

    onConfirm2(vale, index) {
      console.log(this.customerList);
      this.addForm.cargoOwner = this.customerList[index].carrierName;
      this.addForm.cargoOwnerId = this.customerList[index].id;
      this.customer = false;
    },
    onCancel1() {
      this.transf = false;
    },

    onCancel2() {
      this.customer = false;
    },
    onClickBack() {
      this.$router.go(-1);
    },
    // 计划月份
    planyue() {
      this.pandata = true;
    },
    panlick(time) {
      this.addForm.loadDate = this.formatter(time);
      this.pandata = false;
      console.log(this.addForm.loadDate);
    },
    canceldata() {
      this.pandata = false;
    },
    formatter(time) {
      let nowdata = time == null ? new Date() : new Date(time);
      let year = nowdata.getFullYear();
      let month = nowdata.getMonth() + 1;
      let date = nowdata.getDate();
      let nowtime = year + "-";
      if (month < 10) {
        nowtime += "0";
      }
      nowtime += month + "-";
      if (date < 10) {
        nowtime += "0";
      }
      nowtime += date;

      return nowtime;
    },
  },
};
</script>

<style lang="less" scoped>
.dispatchAdd {
  // padding: 10px;
  background-color: #eee;
  min-height: 100vh;

  .nav {
    display: flex;
    align-items: center;
    height: 45px;
    background-color: #44b1f9;

    .title {
      height: 16px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 16px;
      margin: 0 auto;
      // margin-left: -26px;
    }

    .back {
      width: 18px;
      height: 18px;
      margin-top: -2px;
      margin-left: 8px;
    }

    div {
      width: 18px;
      margin-right: 8px;
    }
  }

  .form {
    padding: 10px;

    .boxon {
      border-radius: 8px;
      overflow: hidden;
      .huoname {
        background-color: #fff;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        .icon {
          width: 15px;
          height: 16px;
          margin-right: 6px;
          margin-top: -2px;
        }
      }
    }

    /deep/.van-icon-arrow-down {
      color: #44b1f9;
    }
  }
}
</style>
